import { API_ENV } from '../config';

/**
 * @file
 * Contains Process ENV NODE variables.
 */
export const SYS_BUILD =
  API_ENV === 'dev'
    ? 'Debug'
    : API_ENV === 'qa'
      ? 'QA'
      : API_ENV === 'staging'
        ? 'Staging'
        : 'Production';

const getEnvironment = (() => process.env.NODE_ENV)();
export const isDevelopment = getEnvironment !== 'production';
